import { useContext, useState } from 'react';
import { PrivilegeContext } from '../../../components/priviledge/PriviledgeProvider';
import { InvoiceService } from '../../../services/invoice/invoiceService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage invoices fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de facturas.
----------------------------------------------------------------------------------------*/

const useInvoices = (initialFilters = {}, withPermission = false) => {

    const { userCan } = useContext(PrivilegeContext);
    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchInvoices = async (f?: any) => {
        if (withPermission && !userCan('get_invoices_for_select', 'invoices')) return [];
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const service = new InvoiceService();
            const response = await service.getInvoicesForSelect(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = (fetchedData.data || []).map((item: any) => ({
                    value: item.id,
                    label: item.number,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching invoices:', error);
        }
        return [];
    };

    const getInvoicesList = () => {
        return data;
    };

    return { fetchInvoices, getInvoicesList };
}

export default useInvoices;
